import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core'
import {NgxNavbarModule} from "ngx-bootstrap-navbar";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {RouterModule} from "@angular/router";
import {ContentHeaderComponent} from "../content-header/content-header.component";
import {Location, NgTemplateOutlet} from '@angular/common';
import {ServiceProviderHub} from '@generated-backend-types';
import AuthenticatedContact = ServiceProviderHub.App.Http.Resources.ServiceProviderHub.Auth.AuthenticatedContact;
import {UserSessionService} from '../../services/user-session-service/user-session.service';
import {TitleService} from '../../services/title-service/title.service';
import {BreadcrumbService} from '../../breadcrumb.service';
import {LocaleService} from '../../services/locale-service/locale.service';
import {TranslatePipe} from '@ngx-translate/core';
import {Breadcrumb} from '../../entities/breadcrumb.entity';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgxNavbarModule, BsDropdownModule, RouterModule, ContentHeaderComponent, NgTemplateOutlet, TranslatePipe],
  standalone: true
})
export class HeaderComponent implements OnInit {
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly authService = inject(UserSessionService);
  private readonly titleService = inject(TitleService);
  private readonly breadcrumbService = inject(BreadcrumbService);
  readonly localeService = inject(LocaleService);
  readonly location = inject(Location);

  public title = 'Dashboard'
  public breadcrumbs: Breadcrumb[] = [];
  public user?: Partial<AuthenticatedContact>
  public locale: "de" | "en";

  public constructor() {
    const localeService = this.localeService;

    this.locale = localeService.currentLocale;
    localeService.localeChanged.subscribe(l => this.locale = l);
  }

  public logout(): void {
    this.authService.logout().subscribe({})
  }

  public switchLang(lang: 'de' | 'en'): void {
    this.localeService.setLocale(lang)
  }

  public ngOnInit() {
    this.authService.getStoredUserInfo().subscribe({
      next: value => {
        this.user = value
        this.cdr.markForCheck()
      }
    })
    this.breadcrumbService.breadcrumbs$.subscribe({
      next: value => {
        this.breadcrumbs = value;
        this.cdr.markForCheck();
      }
    });
    this.titleService.title$.subscribe(
      (title) => {
        this.title = title;
        this.cdr.markForCheck()
      }
    )
  }
}
